const headerToolNode = (data) => {
  return {
    type: 'heading',
    id: 'heading-node',
    content: data.toolData,
  };
};

export { headerToolNode };
